import React from 'react'
import AgentRunCard from './AgentRunCard'
import './agentsPage.css'

/**
 * @param {Object} props
 * @param {{ label: string; description: string; icon: import('react').ComponentType<{ size?: number; strokeWidth?: number }> }} props.meta
 * @param {string} props.categoryKey
 * @param {Array<{ pipeline: Record<string, unknown>; agents: Record<string, unknown>[] }>} props.pipelines
 * @param {Record<string, string[]>} props.badgesByAgentKey
 * @param {Record<string, string>} props.statusHintByAgentKey
 * @param {boolean} props.isSuperAdmin
 * @param {boolean} props.hasAnyAnalyzerRun
 * @param {boolean} props.hasSessionAnalyzer
 * @param {(agentKey: string) => void} props.onRun
 */
export default function AgentWorkspaceSection({
  meta,
  categoryKey,
  pipelines,
  badgesByAgentKey,
  statusHintByAgentKey,
  isSuperAdmin,
  hasAnyAnalyzerRun,
  hasSessionAnalyzer,
  onRun,
}) {
  const CategoryIcon = meta.icon
  const taskCreatorRunDisabled = !hasAnyAnalyzerRun && !hasSessionAnalyzer

  return (
    <section className="agents-category">
      <div className="agents-category-header">
        <div className="agents-category-icon">
          <CategoryIcon size={22} strokeWidth={2} />
        </div>
        <div>
          <h2 className="agents-category-title">{meta.label}</h2>
          <p className="agents-category-desc">{meta.description}</p>
        </div>
      </div>

      {pipelines.map(({ pipeline, agents }) => (
        <div key={String(pipeline.id)} className="agents-pipeline-block">
          <p className="agents-pipeline-label">
            Pipeline
            <strong>{pipeline.display_name}</strong>
          </p>
          {pipeline.description ? (
            <p className="agents-category-desc" style={{ margin: '-8px 0 16px' }}>
              {pipeline.description}
            </p>
          ) : null}

          <div className="agents-admin-grid">
            {agents.map((row) => {
              const agentKey = String(row.agent_key)
              return (
                <AgentRunCard
                  key={agentKey}
                  row={row}
                  categoryKey={categoryKey}
                  showStepBadge={agents.length > 1}
                  cornerBadges={badgesByAgentKey[agentKey] || []}
                  statusHint={statusHintByAgentKey[agentKey] || ''}
                  canRun={isSuperAdmin}
                  runDisabled={agentKey === 'basecamp_task_creator' && taskCreatorRunDisabled}
                  runDisabledTitle="Run the Data Analyzer first (or use a saved analyzer run in the modal)"
                  onRun={() => onRun(agentKey)}
                />
              )
            })}
          </div>
        </div>
      ))}
    </section>
  )
}
